import { Routes, Route, Navigate } from "react-router-dom";
import { useAuthStore } from "./stores/auth-store";
import { Layout } from "./components/layout/layout";
import { DashboardPage } from "./routes/index";
import { CompanyDetailPage } from "./routes/company";
import { ComparisonPage } from "./routes/compare";
import { AlertsPage } from "./routes/alerts";
import { ReportsPage } from "./routes/reports";
import { SettingsPage } from "./routes/settings";
import { LoginPage } from "./routes/login";

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/company/:id" element={<CompanyDetailPage />} />
        <Route path="/compare" element={<ComparisonPage />} />
        <Route path="/alerts" element={<AlertsPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
